<template>
  <div class="d-flex flex-column">
    <div class="row align-items-center g-2">
      <div class="col-4">
        <ButtonView type="normal" :color="errors?.path !== undefined || Array.isArray(errors) ? 'warning' : 'secondary'" size="small" class="w-100" @click="selectingOutput = !selectingOutput">
          <OutputView v-if="value.path" :output-path="value.path" :trigger="trigger" :data-types="dataTypes"/>
          <div v-else>
            {{ translate('please_select') }}
          </div>
        </ButtonView>
      </div>
      <div class="col-4">
        <ConditionSelectionView v-if="selectedType" class="w-100 h-100" :conditions="conditions" :output-type="selectedType" :errors="errors?.key" :value="value.key" @update:value="updateValue(item => item.key = $event)"/>
      </div>
      <div class="col-4">
        <AutomationValueInput v-if="selectedType && selectedCondition && selectedCondition.requiresValue" class="w-100" :community-id="communityId" :type="selectedType" :value="value.value" @update:value="updateValue(item => item.value = $event)" :errors="errors?.value"/>
      </div>
    </div>
    <OutputSelectionView v-model:active="selectingOutput" comparable :trigger="trigger" :value="value.path" @update:value="updateValue(item => { item.path = $event; item.key = undefined; item.value = undefined })" :data-types="dataTypes"/>
  </div>
</template>

<script>
import AutomationValueInput from "@/systems/modules/automation/form/AutomationValueInput.vue";
import OutputSelectionView from "@/systems/modules/automation/form/OutputSelectionView.vue";
import ConditionSelectionView from "@/systems/modules/automation/form/conditions/ConditionSelectionView.vue";
import OutputView from "@/systems/modules/automation/form/OutputView.vue";
import {ButtonView} from "@/niftybit";

export default {
  name: "ConditionView",
  components: {ButtonView, OutputView, AutomationValueInput, OutputSelectionView, ConditionSelectionView},
  props: {
    communityId: String,
    trigger: Object,
    value: Object,
    dataTypes: Array,
    conditions: Array,
    errors: [Object, Array]
  },
  emits: ["update:value"],
  data() {
    return {
      selectingOutput: false
    }
  },
  methods: {
    updateValue(callback) {
      let item = JSON.parse(JSON.stringify(this.value));
      callback(item);
      this.$emit("update:value", item);
    }
  },
  computed: {
    selectedType() {
      if (!this.value?.path) return undefined;
      let split = this.value.path.split(".");
      const triggerOutput = this.trigger.outputs.find(item => item.key === split[0]);
      let output = this.dataTypes.find(item => item.key === triggerOutput.type.key);
      for (let i = 1; i < split.length; i++) {
        const itemOutput = output.outputs.find(item => item.key === split[i]);
        output = this.dataTypes.find(item => item.key === itemOutput.type.key);
      }
      return output;
    },
    selectedCondition() {
      return this.value?.key ? this.conditions.find(item => item.key === this.value.key) : undefined;
    }
  }
}
</script>

<style scoped>

</style>